// 页面滚动
(function () {
    // 设置触发标志
    let scrollPoints = {
      25: false,
      50: false,
      75: false,
      100: false,
    };
  
    function sendScrollEvent(percentage) {
      Shopify.analytics.publish('page_scroll', { scroll_percent: `${percentage}%` });
    }
  
    window.addEventListener('scroll', () => {
      // 页面可视高度
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
  
      // 计算滚动百分比
      const scrollPercent = Math.round(((scrollTop + windowHeight) / documentHeight) * 100);
  
      // 检查各个滚动触发点
      if (scrollPercent >= 25 && !scrollPoints['25']) {
        sendScrollEvent(25);
        scrollPoints['25'] = true;
      }
      if (scrollPercent >= 50 && !scrollPoints['50']) {
        sendScrollEvent(50);
        scrollPoints['50'] = true;
      }
      if (scrollPercent >= 75 && !scrollPoints['75']) {
        sendScrollEvent(75);
        scrollPoints['75'] = true;
      }
      if (scrollPercent >= 100 && !scrollPoints['100']) {
        sendScrollEvent(100);
        scrollPoints['100'] = true;
      }
    });
  })();
  
  
  // 国家语言选择器
  function countryClickGA() {
    const listItems = document.querySelectorAll('.country-select-container .country-main-content .main-content-item');
    if (listItems?.length > 0) {
      listItems.forEach((item, _) => {
        const linkList = item.querySelectorAll('.main-content-item-list .main-content-item-list-item');
        linkList.forEach((linkItem, _) => {
          linkItem.addEventListener("click", () => {
  
            const country = linkItem.querySelector('.item-counry');
            const language = linkItem.querySelector('.item-language');
            const countryText = country?.textContent?.trim();
            const languageText = language?.textContent?.trim();
            Shopify.analytics.publish('language_click', { button: `${countryText}_${languageText}` });
          });
        })
      });
    }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
  
    // ----------------------------------------------
    // ------------------ 全局事件 -------------------
    // 获取内容分组数据，pageview用
    function getGroupDataGA() {
      const x_uid = window.xrealUserId;
      const local_x_uid = localStorage.getItem('xreal-uid');
      if (x_uid && !local_x_uid) getHashString36(x_uid).then(hash => localStorage.setItem('xreal-uid', hash));
      const country = document.querySelector('.country-select-action .footer-country-name');
      const countryText = country.innerText.trim();
      const site_language = countryText.replace(/\s*\/\s*/g, "_");
      localStorage.setItem('xreal-site_language', site_language);
    }
    getGroupDataGA();
  
    // 顶部通知栏曝光
    function navigationViewGA() {
      const processedSlides = new Set();
      const slides = document.querySelectorAll(".announcement-bar-section .swiper-slide");
      // 检查页面首次加载时是否有 `swiper-slide-active`
      slides.forEach((slide) => {
        if (slide.classList.contains("swiper-slide-active") && !processedSlides.has(slide)) {
          const policyDiv = slide.querySelector(".xreal-policy-bar");
          const title = slide.querySelector('a');
          const titleText = !policyDiv ? title?.innerText?.trim() : 'others';
          processedSlides.add(slide);
          Shopify.analytics.publish('nav_view', { general_title: titleText });
        }
      });
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const slide = mutation.target;
            if (slide.classList.contains("swiper-slide-active") && !processedSlides.has(slide)) {
              const policyDiv = slide.querySelector(".xreal-policy-bar");
              const title = slide.querySelector('a');
              const titleText = !policyDiv ? title?.innerText?.trim() : 'others';
              processedSlides.add(slide);
              Shopify.analytics.publish('nav_view', { general_title: titleText });
            }
          }
        });
      });
      // 为每个 slide 设置监听
      slides.forEach((slide) => {
        observer.observe(slide, { attributes: true });
      });
    }
    navigationViewGA();
  
    // 顶部通知栏点击
    function navigationClickGA() {
      const listItems = document.querySelectorAll('.announcement-bar-section .swiper-slide');
      if (listItems?.length > 0) {
        listItems.forEach((item, _) => {
          const policyDiv = item.querySelector(".xreal-policy-bar");
          const datecountDiv = item.querySelector(".date-count-wrapper");
          if (policyDiv) {
            const policyItems = policyDiv.querySelectorAll("a");
            policyItems.forEach((policy, _) => {
              const btn = policy.querySelector("span");
              const btnText = btn.innerText.trim();
              policy.addEventListener("click", () => {
                const params = {
                  button: btnText,
                  general_title: 'policy',
                }
                Shopify.analytics.publish('nav_click', params);
              });
            })
          } else if (datecountDiv) {
            const link = datecountDiv.querySelector("a");
            const titleText = link.innerText.trim();
            link.addEventListener("click", () => {
              const params = {
                button: titleText,
                general_title: titleText,
              }
              Shopify.analytics.publish('nav_click', params);
            });
          } else {
            const anchor = item.querySelector('a');
            const titleText = anchor.innerText.trim();
            anchor.addEventListener("click", () => {
              const params = {
                button: titleText,
                general_title: titleText,
              }
              Shopify.analytics.publish('nav_click', params);
            });
          }
        });
      }
    }
    navigationClickGA();
  
    // header 点击
    function headerIconClickGA(btnSelector, btnText) {
      const currentButton = document.querySelector(btnSelector);
      if (currentButton) {
        currentButton.addEventListener("click", () => {
          Shopify.analytics.publish('header_click', { button: btnText });
        });
      }
    }
    headerIconClickGA('.header__heading-link', 'XREAL SHOP');
    headerIconClickGA('.header__icon--search', 'search');
    headerIconClickGA('.header__icon--account', 'account');
    headerIconClickGA('.header__icon--cart', 'cart');
    headerIconClickGA('.header__icon--menu', 'menu');
  
    function headerNavClickGA(categoryClass, productClass) {
      const listItems = document.querySelectorAll(categoryClass);
      if (listItems?.length > 0) {
        listItems.forEach((item, _) => {
          const btn = item.querySelector('a');
          const btnText = btn?.textContent?.trim();
          item.addEventListener("click", () => {
            console.log('--------NavClick +', `${btnText}_+`)
            Shopify.analytics.publish('header_click', { button: `${btnText}_+` });
          });
          btn.addEventListener("click", (event) => {
            event.stopPropagation(); // 阻止事件冒泡
            console.log('--------NavClick cate', btnText)
            Shopify.analytics.publish('header_click', { button: btnText });
          });
          const productList = item.querySelectorAll(productClass);
          productList.forEach((product, _) => {
            product.addEventListener("click", (event) => {
              event.stopPropagation(); // 阻止事件冒泡
              // const title = product.querySelector('span');
              const btnText = product?.innerText?.trim();
              console.log('--------NavClick product', btnText)
              Shopify.analytics.publish('header_click', { button: btnText });
            });
          })
        });
      }
    }
    headerNavClickGA('.xreal-header-nav ul li', '.xreal-menu-collection a');
    headerNavClickGA('.menu-drawer__navigation ul li', '.xreal-menu-collection .xreal-menu-collection-item');
  
    // footer 点击
    function footerIconClickGA(btnSelector, btnText) {
      const currentButton = document.querySelector(btnSelector);
      console.log(currentButton);
      
      const currentButtonText = currentButton?.textContent?.trim();
      if (currentButton) {
        currentButton.addEventListener("click", () => {
          Shopify.analytics.publish('footer_click', { button: btnText ? btnText : currentButtonText });
        });
      }
    }
    footerIconClickGA('.newsletter-form__button', 'email');
    footerIconClickGA('.country-select-action .footer-country-name', 'country');
  
    function footerLinksClickGA() {
      const listItems = document.querySelectorAll('.footer__blocks-wrapper .footer-links-item');
      if (listItems?.length > 0) {
        listItems.forEach((item, _) => {
          const linkList = item.querySelectorAll('ul li');
          linkList.forEach((linkItem, _) => {
            const link = linkItem.querySelector('a');
            link.addEventListener("click", () => {
              const btnText = link?.textContent?.trim();
              Shopify.analytics.publish('footer_click', { button: btnText });
            });
          })
        });
      }
    }
    footerLinksClickGA();
  
    // 订阅成功
    function subscribeSuccessGA() {
      const urlParams = new URLSearchParams(window.location.search);
      const hashParams = window.location.hash;
      const customerPosted = urlParams.get("customer_posted");
      const hashValue = hashParams.slice(1);
      if (customerPosted === "true" && hashValue === "footer-newsletter") {
        Shopify.analytics.publish('subscribe_success', { module: 'footer navigation' });
      }
    }
    subscribeSuccessGA();
  
    // 悬浮图标（客服、subscribe）
    function floatBtnClickGA(btnSelector, btnText) {
      const currentButton = document.querySelector(btnSelector);
      if (currentButton) {
        currentButton.addEventListener("click", () => {
          Shopify.analytics.publish('float_click', { button: btnText });
        });
      }
    }
    floatBtnClickGA('.udesk-client-btn', 'customer service')
    floatBtnClickGA('.kl-teaser-TiTr3h', 'Subscribe')
    // ----------------------------------------------
    // ----------------- 首页点击 --------------------
    // banner点击（video）
    // TODO: 12.9：发现结构修改，似乎不会触发这个，测试无误后删除
    // function homeVideoBannerClickGA() {
    //   const currentButton = document.querySelector('.index-slide .slide-main a');
    //   const currentTitle = document.querySelector('.index-slide .slide-main h3');
    //   const currentDesc = document.querySelector('.index-slide .slide-main p');
    //   const currentButtonText = currentButton?.textContent?.trim();
    //   const currentTitleText = currentTitle?.textContent?.trim();
    //   const currentDescText = currentDesc?.textContent?.trim();
    //   if (currentButton) {
    //     currentButton.addEventListener("click", () => {
    //       const params = {
    //         button: currentButtonText,
    //         general_title: currentTitleText || currentDescText,
    //       }
    //       Shopify.analytics.publish('home_banner_click', params);
    //     });
    //   }
    // }
    // homeVideoBannerClickGA();
  
    // banner点击
    function homeBannerClickGA() {
      const listItems = document.querySelectorAll('.index-slide .swiper-wrapper>a');
      if (listItems?.length > 0) {
        const module = listItems?.length > 1 ? 'home dynamic promotion' : 'home static promotion';
        listItems.forEach((item, index) => {
          item.addEventListener("click", () => {
            const imgEle = item.querySelector('.slide-bac img');
            const imgSrc = imgEle.getAttribute('src');
            const params = {
              button: `${imgSrc}`,
              general_title: `${index}`,
              module: `${module}`
            }
            Shopify.analytics.publish('home_banner_click', params);
          });
        });
      }
    }
    homeBannerClickGA();
  
    // 主推商品（单个）
    function homeProductClickGA() {
      const product = document.querySelector('.product-feature-item');
      const currentButton = document.querySelector('.xreal-feature-product-container .card_product-link a');
      const currentProduct = document.querySelector('.xreal-feature-product-container .product__information h3 a');
      const currentModel = document.querySelector('.xreal-feature-product-container header h2');
      const currentButtonText = currentButton?.textContent?.trim();
      const currentProductText = currentProduct?.textContent?.trim();
      const currentModelText = currentModel?.textContent?.trim();
      if (product) {
        product.addEventListener("click", () => {
          const params = {
            button: currentButtonText,
            general_title: currentProductText,
            module: currentModelText
          }
          Shopify.analytics.publish('home_item_click', params);
        });
      }
    }
    homeProductClickGA();
  
    // 分类商品(列表)
    function homeProductItemClickGA() {
      const currentModel = document.querySelector('.x-best-sellers header h3');
      const currentModelText = currentModel?.textContent?.trim();
      const listItems = document.querySelectorAll('.x-best-sellers .swiper-slide');
      if (listItems?.length > 0) {
        listItems.forEach((item, index) => {
          const btn = item.querySelector('.card_product-link a');
          item.addEventListener("click", () => {
            const currentButtonText = btn?.textContent?.trim();
            const currentTitle = item.querySelector(".product__information h3 a");
            const currentTitleText = currentTitle?.textContent?.trim();
            const params = {
              button: currentButtonText,
              general_title: currentTitleText,
              module: currentModelText
            }
            Shopify.analytics.publish('home_item_click', params);
          });
        });
      }
    }
    homeProductItemClickGA();
  
    // 商品类别点击
    function homeCategoryClickGA() {
      const listItems = document.querySelectorAll('.x-category-entry a');
      if (listItems?.length > 0) {
        listItems.forEach((item, index) => {
          item.addEventListener("click", () => {
            const currentTitle = item.querySelector("h3");
            const currentTitleText = currentTitle?.textContent?.trim();
            Shopify.analytics.publish('home_category_click', { button: currentTitleText });
          });
        });
      }
    }
    homeCategoryClickGA();
  
    // ----------------------------------------------
    // --------------- 商品列表点击 -------------------
    function productListClickGA() {
      const listItems = document.querySelectorAll('#ProductGridContainer .collection ul li');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector("facet-filters-form .collection-info h2");
        const titleText = currentTitle?.textContent?.trim();
        listItems.forEach((item, index) => {
          item.addEventListener("click", () => {
            const product = item.querySelector('h3 a');
            const productText = product?.textContent?.trim();
  
            const params = {
              item_list_name: titleText || 'Search results',
              item_name: productText,
              index: index,
              item_category: titleText
            }
            Shopify.analytics.publish('select_item', params);
          })
        })
      }
    }
    productListClickGA();
  
    // ----------------------------------------------
    // --------------- 推荐商品点击 -------------------
    function recommendMiniCartClickGA() {
      const listItems = document.querySelectorAll('.cart-recommendations ul li');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector(".cart-recommendations-wrapper .header-title");
        const titleText = currentTitle?.textContent?.trim();
        listItems.forEach((item, _) => {
          const btn = item.querySelector('.product__information h3 a');
          btn.addEventListener("click", () => {
            const btnText = btn?.textContent?.trim();
            const params = {
              button: btnText,
              general_title: btnText,
              module: `${titleText}_Your cart`
            }
            Shopify.analytics.publish('recommend_item_click', params);
          })
        })
      }
    }
    recommendMiniCartClickGA();
  
    function recommendCartClickGA() {
      const listItems = document.querySelectorAll('.collection ul li');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector(".collection__title h2");
        const titleText = currentTitle?.textContent?.trim();
        listItems.forEach((item, _) => {
          item.addEventListener("click", () => {
            const btn = item.querySelector('.card__information h3 a');
            const btnText = btn?.textContent?.trim();
            const params = {
              button: btnText,
              general_title: btnText,
              module: `${titleText}_Your cart`
            }
            Shopify.analytics.publish('recommend_item_click', params);
          })
        })
      }
    }
    if (window.location.pathname.includes("/cart")) {
      recommendCartClickGA();
    }
  
    function recommendDetailClickGA() {
      const listItems = document.querySelectorAll('product-recommendations ul li');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector("product-recommendations header h2");
        const titleText = currentTitle?.textContent?.trim();
        listItems.forEach((item, _) => {
          item.addEventListener("click", () => {
            const btn = item.querySelector('.card_product-link a');
            const btnText = btn?.textContent?.trim();
            const product = item.querySelector('.product__information h3 a');
            const productText = product?.textContent?.trim();
            const params = {
              button: btnText,
              general_title: productText,
              module: `${titleText}_productDetail`
            }
            Shopify.analytics.publish('recommend_item_click', params);
          })
        })
      }
    }
    recommendDetailClickGA();
  
    function recommendCollectionClickGA() {
      const listItems = document.querySelectorAll('.x-recommend .swiper-slide');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector(".x-recommend header h3");
        const titleText = currentTitle?.textContent?.trim();
        const collection = document.querySelector(".collection-info h2");
        const collectionText = collection?.textContent?.trim();
        listItems.forEach((item, _) => {
          item.addEventListener("click", () => {
            const btn = item.querySelector('.card_product-link a');
            const btnText = btn?.textContent?.trim();
            const product = item.querySelector('.product__information h3 a');
            const productText = product?.textContent?.trim();
            const params = {
              button: btnText,
              general_title: productText,
              module: `${titleText}_${collectionText}`
            }
            Shopify.analytics.publish('recommend_item_click', params);
          })
        })
      }
    }
    recommendCollectionClickGA();
  
    function recommendBlogClickGA() {
      const listItems = document.querySelectorAll('.main-blog-wrapper .x-feature-aside .featured-list .product-item');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector(".x-feature-aside .featured-title a");
        const titleText = currentTitle?.textContent?.trim();
        listItems.forEach((item, _) => {
          item.addEventListener("click", () => {
            const btn = item.querySelector('.card_product-link a');
            const btnText = btn?.textContent?.trim();
            const product = item.querySelector('.product__information h3 a');
            const productText = product?.textContent?.trim();
            const params = {
              button: btnText,
              general_title: productText,
              module: `${titleText}_blog`
            }
            Shopify.analytics.publish('recommend_item_click', params);
          })
        })
      }
    }
    recommendBlogClickGA();
  
    // ----------------------------------------------
    // ---------------- 购物车按钮点击 ----------------
    function cartBtnClickGA(selector, buttonText) {
      const currentButton = document.querySelector(selector);
      if (currentButton) {
        currentButton.addEventListener("click", () => {
          Shopify.analytics.publish('cart_click', { button: buttonText });
        });
      }
    }
    // 购物车弹窗 Continue Shopping 按钮
    cartBtnClickGA(".cart-drawer__empty-content .primary-btn", 'Continue Shopping');
  
    // 购物车弹窗 Check Out 按钮点击
    cartBtnClickGA("#CartDrawer-Checkout", 'Check out');
  
    // 购物车 Continue Shopping 按钮
    cartBtnClickGA("cart-items .title-wrapper-with-link a", 'Continue Shopping');
    cartBtnClickGA("cart-items .cart__warnings .button", 'Continue Shopping');
  
    // 购物车 Check Out 按钮点击
    cartBtnClickGA(".cart__footer-wrapper #checkout", 'Check out');
  
    // 购物车弹窗
    function cartDrawerShowGA() {
      const cartDrawer = document.querySelector("cart-drawer");
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const isActive = cartDrawer.classList.contains("active");
            if (isActive) {
              const drawerItems = document.querySelector("cart-drawer-items");
              const isEmpty = drawerItems.classList.contains('is-empty');
              if (isEmpty) {
                Shopify.analytics.publish('cart_drawer_viewed', { currency: undefined, value: undefined, cart_list: undefined });
              } else {
                const total = cartDrawer.querySelector(".totals__total-total");
                const totalParse = parsePrice(total?.textContent);
                const listItems = drawerItems.querySelectorAll('.cart-items .cart-item');
                const cart_list = [...listItems].map((item, _) => {
                  const product = item.querySelector('.cart-item__name');
                  const productText = product?.textContent?.trim();
                  const productQuantity = item.querySelector('.quantity__input');
                  const productQuantityText = productQuantity?.value;
                  const productPrice = item.querySelector('.price--end');
                  const productPriceText = productPrice?.textContent?.trim();
                  const productPriceParse = parsePrice(productPriceText);
                  const priceAmount = productPriceParse.amount;
                  const listItem = {
                    item_name: productText,
                    quantity: productQuantityText,
                    price: priceAmount,
                    currency: totalParse.currency,
                    item_category: 'event'
                  }
                  return listItem;
                })
                Shopify.analytics.publish('cart_drawer_viewed', { currency: totalParse.currency, value: totalParse.amount, cart_list: cart_list });
              }
            }
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true });
    }
    cartDrawerShowGA()
    // ----------------------------------------------
    // ----------------- 商详页点击 -------------------
    function productDetailClickGA(selector, buttonText, isBuyButton = false) {
      const xCurrentProduct = getCurrentProduct();
      const currentButton = document.querySelector(selector);
      const currentButtonText = currentButton?.textContent?.trim();
      const generalTitle = isBuyButton ? xCurrentProduct : currentButtonText;
      if (currentButton) {
        currentButton.addEventListener("click", () => {
          Shopify.analytics.publish('productDetail_click', { button: buttonText, general_title: generalTitle });
        });
      }
    }
    // Buy with shop pay 按钮
    productDetailClickGA("shop-pay-wallet-button", 'Buy with shop pay', true);
  
    // More payment options 按钮
    productDetailClickGA("more-payment-options-link", 'More payment options', true);
  
    // Buy it now 按钮
    productDetailClickGA("shopify-buy-it-now-button", 'Buy it now', true);
  
    // 点击商品相关 bundle 标题
    productDetailClickGA(".product-combination h3 a", 'option title');
  
    // ----------------------------------------------
    // ----------------- 博客页点击 -------------------
    function blogClickGA() {
      const listItems = document.querySelectorAll('#bloggy--article .bggle_table-of-content .bggle--anchor');
      if (listItems?.length > 0) {
        const currentTitle = document.querySelector(".article-template__title");
        const generalTitle = currentTitle?.textContent?.trim();
        listItems.forEach((item, _) => {
          item.addEventListener("click", () => {
            const buttonText = item?.textContent?.trim();
            Shopify.analytics.publish('blog_click', { button: buttonText, general_title: generalTitle });
          });
        });
      }
    }
    blogClickGA();
  });
  